export const FETCH_MODIFIER_LOOKUP_REQUEST = "FETCH_MODIFIER_LOOKUP_REQUEST";
export const FETCH_MODIFIER_LOOKUP_SUCCESS = "FETCH_MODIFIER_LOOKUP_SUCCESS";
export const FETCH_MODIFIER_LOOKUP_FAILURE = "FETCH_MODIFIER_LOOKUP_FAILURE";
